<template>
  <div class="cdd-pool">
    <div class="top-row">
      <div class="filter">
        <sui-dropdown
          v-model="current"
          button
          class="icon"
          floating
          labeled
          :options="languages"
          text="Sort Candidate"
        />
      </div>
      <div class="inprogress-email-btn">
        <router-link to="/dashboard/cdd-pool/pending-email">
          <button class="btn btn-outline" type="submit">
            <i class="las la-envelope-open-text"></i
            ><span class="text">Pending Invitation</span>
          </button>
        </router-link>
      </div>
    </div>
    <div class="filter-row">
      <div class="label">CANDIDATE STATUS</div>
      <div class="filters">
        <a class="filter-btn status-all active">All</a>
        <a class="filter-btn status-available">Available</a>
        <a class="filter-btn status-registered">Registered</a>
      </div>
    </div>
    <div class="cdd-list">
      <div class="cdd-item">
        <div class="wrap">
          <div class="status-sticker"><CddStatusRegistered /></div>
          <div class="heading">
            <span class="name">
              <router-link to="/dashboard/cdd-pool/details">
                <a class="link" href=" ">Arakawa Kaoru</a>
              </router-link></span
            >
            <span class="cdd-id">CID: 123456</span>
          </div>
          <div class="basic-info">
            <div class="item icon-text">
              <i class="las la-phone"></i>
              <div class="text">
                <a class="link" href="tel:660992526677">0992526677</a>
              </div>
            </div>
            <div class="item icon-text">
              <i class="las la-envelope"></i>
              <div class="text">
                <a class="link" href="mailto:email@email.com"
                  >arakawa@email.com</a
                >
              </div>
            </div>
            <div class="item label-text">
              <div class="label">English Level</div>
              <div class="text">Intermediate</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Job Categry</div>
              <div class="text">Engineering / Telecommunications</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Industry</div>
              <div class="text">Infrastructure Engineering</div>
            </div>
            <div class="item label-text">
              <div class="label">Expected Salary</div>
              <div class="text">100,000 - 150,000 THB</div>
            </div>
          </div>
        </div>
      </div>
      <div class="cdd-item">
        <div class="wrap">
          <div class="status-sticker"><CddStatusAvailable /></div>
          <div class="heading">
            <span class="name">
              <router-link to="/dashboard/cdd-pool/details">
                <a class="link" href=" ">Darrel Hawkins</a>
              </router-link></span
            >
            <span class="cdd-id">CID: 123456</span>
          </div>
          <div class="basic-info">
            <div class="item icon-text">
              <i class="las la-phone"></i>
              <div class="text">
                <a class="link" href="tel:660992526677">0992526677</a>
              </div>
            </div>
            <div class="item icon-text">
              <i class="las la-envelope"></i>
              <div class="text">
                <a class="link" href="mailto:email@email.com"
                  >arakawa@email.com</a
                >
              </div>
            </div>
            <div class="item label-text">
              <div class="label">English Level</div>
              <div class="text">Intermediate</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Job Categry</div>
              <div class="text">Engineering / Telecommunications</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Industry</div>
              <div class="text">Infrastructure Engineering</div>
            </div>
            <div class="item label-text">
              <div class="label">Expected Salary</div>
              <div class="text">100,000 - 150,000 THB</div>
            </div>
          </div>
        </div>
      </div>
      <div class="cdd-item">
        <div class="wrap">
          <div class="status-sticker"><CddStatusAvailable /></div>
          <div class="heading">
            <span class="name">
              <router-link to="/dashboard/cdd-pool/details">
                <a class="link" href=" ">Landon Hutton</a>
              </router-link></span
            >
            <span class="cdd-id">CID: 123456</span>
          </div>
          <div class="basic-info">
            <div class="item icon-text">
              <i class="las la-phone"></i>
              <div class="text">
                <a class="link" href="tel:660992526677">0992526677</a>
              </div>
            </div>
            <div class="item icon-text">
              <i class="las la-envelope"></i>
              <div class="text">
                <a class="link" href="mailto:email@email.com"
                  >arakawa@email.com</a
                >
              </div>
            </div>
            <div class="item label-text">
              <div class="label">English Level</div>
              <div class="text">Intermediate</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Job Categry</div>
              <div class="text">Engineering / Telecommunications</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Industry</div>
              <div class="text">Infrastructure Engineering</div>
            </div>
            <div class="item label-text">
              <div class="label">Expected Salary</div>
              <div class="text">100,000 - 150,000 THB</div>
            </div>
          </div>
        </div>
      </div>
      <div class="cdd-item">
        <div class="wrap">
          <div class="status-sticker"><CddStatusAvailable /></div>
          <div class="heading">
            <span class="name">
              <router-link to="/dashboard/cdd-pool/details">
                <a class="link" href=" ">Keiran Bellamy</a>
              </router-link></span
            >
            <span class="cdd-id">CID: 123456</span>
          </div>
          <div class="basic-info">
            <div class="item icon-text">
              <i class="las la-phone"></i>
              <div class="text">
                <a class="link" href="tel:660992526677">0992526677</a>
              </div>
            </div>
            <div class="item icon-text">
              <i class="las la-envelope"></i>
              <div class="text">
                <a class="link" href="mailto:email@email.com"
                  >arakawa@email.com</a
                >
              </div>
            </div>
            <div class="item label-text">
              <div class="label">English Level</div>
              <div class="text">Intermediate</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Job Categry</div>
              <div class="text">Engineering / Telecommunications</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Industry</div>
              <div class="text">Infrastructure Engineering</div>
            </div>
            <div class="item label-text">
              <div class="label">Expected Salary</div>
              <div class="text">100,000 - 150,000 THB</div>
            </div>
          </div>
        </div>
      </div>
      <div class="cdd-item">
        <div class="wrap">
          <div class="status-sticker"><CddStatusRegistered /></div>
          <div class="heading">
            <span class="name">
              <router-link to="/dashboard/cdd-pool/details">
                <a class="link" href=" ">Mariya Peck</a>
              </router-link></span
            >
            <span class="cdd-id">CID: 123456</span>
          </div>
          <div class="basic-info">
            <div class="item icon-text">
              <i class="las la-phone"></i>
              <div class="text">
                <a class="link" href="tel:660992526677">0992526677</a>
              </div>
            </div>
            <div class="item icon-text">
              <i class="las la-envelope"></i>
              <div class="text">
                <a class="link" href="mailto:email@email.com"
                  >arakawa@email.com</a
                >
              </div>
            </div>
            <div class="item label-text">
              <div class="label">English Level</div>
              <div class="text">Intermediate</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Job Categry</div>
              <div class="text">Engineering / Telecommunications</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Industry</div>
              <div class="text">Infrastructure Engineering</div>
            </div>
            <div class="item label-text">
              <div class="label">Expected Salary</div>
              <div class="text">100,000 - 150,000 THB</div>
            </div>
          </div>
        </div>
      </div>
      <div class="cdd-item">
        <div class="wrap">
          <div class="status-sticker"><CddStatusRegistered /></div>
          <div class="heading">
            <span class="name">
              <router-link to="/dashboard/cdd-pool/details">
                <a class="link" href=" ">Bethanie Kemp</a>
              </router-link></span
            >
            <span class="cdd-id">CID: 123456</span>
          </div>
          <div class="basic-info">
            <div class="item icon-text">
              <i class="las la-phone"></i>
              <div class="text">
                <a class="link" href="tel:660992526677">0992526677</a>
              </div>
            </div>
            <div class="item icon-text">
              <i class="las la-envelope"></i>
              <div class="text">
                <a class="link" href="mailto:email@email.com"
                  >arakawa@email.com</a
                >
              </div>
            </div>
            <div class="item label-text">
              <div class="label">English Level</div>
              <div class="text">Intermediate</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Job Categry</div>
              <div class="text">Engineering / Telecommunications</div>
            </div>
            <div class="item label-text">
              <div class="label">Experienced Industry</div>
              <div class="text">Infrastructure Engineering</div>
            </div>
            <div class="item label-text">
              <div class="label">Expected Salary</div>
              <div class="text">100,000 - 150,000 THB</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="add-candidate">
      <sui-button @click.native="toggle">
        <button class="btn btn-blue" type="submit">
          <i class="las la-plus"></i><span class="text">Add Candidate</span>
        </button>
      </sui-button>
    </div>
    <sui-modal v-model="open">
      <div class="modal-custom">
        <sui-button class="close-btn" @click.native="toggle">
          <button type="button">
            <i class="las la-times"></i>
          </button>
        </sui-button>
        <div class="heading">Add Your Candidate</div>
        <div class="description">
          Simply add your candidate’s required information below. Sourcedout
          will send a registration to this candidate
        </div>
        <div class="register">
          <div class="ui form">
            <sui-form-field required>
              <label>Candidate's Name</label>
              <input
                type="email"
                name="email"
                placeholder="Enter candidate's name"
              />
            </sui-form-field>
            <sui-form-field required>
              <label>Candidate's Email</label>
              <input
                type="email"
                name="email"
                placeholder="Enter candidate's email address"
              />
            </sui-form-field>
          </div>
        </div>
        <div class="button-row">
          <button class="btn fab" type="submit">Send Registration</button>
          <!-- <sui-button @click.native="toggle">
            <button class="btn btn-outline cancel" type="submit">Cancel</button>
          </sui-button> -->
        </div>
      </div>
    </sui-modal>
    <div class="paging">
      <Pagination />
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import Pagination from "../../components/ui/Pagination";
import CddStatusRegistered from "../components/cdd-status-sticker/CddStatusRegistered.vue";
import CddStatusAvailable from "../components/cdd-status-sticker/CddStatusAvailable.vue";
export default {
  name: "DashboardCddPool",
  components: {
    Pagination,
    CddStatusRegistered,
    CddStatusAvailable,
  },
  data() {
    return {
      current: null,
      languages: [
        { key: "Candidate ID", text: "Candidate ID", value: "Candidate ID" },
        { key: "Name", text: "Name", value: "Name" },
        {
          key: "Experienced Job Category",
          text: "Experienced Job Category",
          value: "Experienced Job Category",
        },
        {
          key: "Experienced Industry",
          text: "Experienced Industry",
          value: "Experienced Industry",
        },
        {
          key: "Expected Salary",
          text: "Expected Salary",
          value: "Expected Salary",
        },
      ],
    };
  },
  data() {
    return { open: false };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
  mounted() {
    $(document).ready(function () {
      $(".filter-btn").click(function () {
        $(".filters").find(".active").removeClass("active");
        $(this).addClass("active");
      });
    });
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/application";
@import "@/assets/stylesheets/register";

//Filter Dropdown Custom Style
/deep/.ui.floating.dropdown > .menu {
  margin-top: 12px !important;
  overflow: scroll;
  max-height: 15rem;
  background: white !important;
}
.ui.icon.button {
  background: none;
  border-radius: 100rem;
  font-family: "Poppins", sans-serif;
  border: 2px solid $blue-primary;
  z-index: 20;
  &:hover,
  &:focus {
    /* stylelint-disable-next-linedeclaration-no-important */
    box-shadow: none !important;
    filter: contrast(150%);
    text-decoration: none;
    background: none;
  }
}
/deep/.ui.labeled.icon.button {
  padding-left: 45px !important;
  padding: 1rem;
}
/deep/ .ui.dropdown > .dropdown.icon {
  background: none !important;
}
/deep/.ui.dropdown > .dropdown.icon:before {
  color: $blue-primary !important;
  content: "\f0b0";
  font-family: "Line Awesome Free";
  font-weight: 900;
  margin-left: 10px;
  font-size: 24px !important;
}
/deep/.ui.dropdown > .text {
  color: $blue-primary !important;
  font-size: 15px;
  font-weight: 700;
}

.cdd-pool {
  position: relative;
  .top-row {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .inprogress-email-btn {
      .btn {
        border: 2px solid #4d4d4d;
        color: #4d4d4d;
        margin-left: 10px;
        i {
          font-size: 22px;
          height: auto;
          margin: 0;
          margin-right: 15px;
        }
      }
    }
  }
  .filter-row {
    display: flex;
    align-items: center;
    padding: 2rem 0;
    padding-bottom: 1rem;
    .label {
      font-size: 12px;
      font-weight: 500;
      color: #787a7a;
      text-transform: uppercase;
      margin-right: 15px;
    }
    .filters {
      .filter-btn {
        display: inline-flex;
        font-family: "Poppins", sans-serif !important;
        font-weight: 700;
        font-size: 14px;
        font-weight: 700;
        border-radius: 100rem !important;
        background: gray;
        padding: 4px 10px;
        color: $white;
        cursor: pointer;
        white-space: nowrap;
        opacity: 0.6;
        transition: all 0.4s ease-in-out;
        margin-right: 10px;
      }
      .filter-btn.active {
        opacity: 1;
      }
      .status-all {
        background: $black;
      }
      .status-available {
        background: #20bf6b;
      }
      .status-registered {
        background: #139eff;
      }
    }
  }
  .cdd-list {
    padding: 2rem 0;
    .cdd-item {
      background: #fafafa;
      margin-bottom: 1rem;
      padding: 20px 15px;
      padding-bottom: 10px;
      width: 100%;
      .link {
        color: $black;
        &:hover,
        &:focus {
          color: #4d4d4d;
        }
      }
      .wrap {
        position: relative;
        .status-sticker {
          position: absolute;
          bottom: 0.5rem;
          right: 0;
        }
        .heading {
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name {
            font-size: 1.15em;
            color: $black;
            font-weight: 700;
          }
          .cdd-id {
            color: $gray;
            font-size: 1.15em;
            font-weight: 700;
          }
        }
        .basic-info {
          padding-top: 1rem;
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          .item {
            color: $black;
            font-weight: 500;
            font-size: 1em;
            flex: 0 0 50%;
            margin-bottom: 10px;
          }
          .icon-text {
            display: flex;
            align-items: center;
            flex-direction: row;
            i {
              color: $blue-primary;
              font-size: 20px;
              margin-right: 10px;
            }
          }
          .label-text {
            .label {
              font-weight: 700;
              margin-bottom: 5px;
            }
          }
        }
      }
    }
  }
  .add-candidate {
    position: fixed;
    z-index: 1000;
    bottom: 50px;
    right: 20px;
    // transform: translate(-50%, -50%);
    .btn {
      min-width: 120px;
      box-shadow: rgba(33, 35, 38, 0.1) 0px 10px 10px -5px;
      i {
        font-size: 22px;
        height: auto;
        margin: 0;
        margin-right: 15px;
      }
    }
  }
  .modal-custom {
    font-family: "Poppins", sans-serif !important;
    text-align: center;
    padding: 2rem 2rem;
    line-height: 1.5rem;
    color: $black;
    & > * {
      margin-bottom: 1.5rem;
    }
    & > *:last-child {
      margin-bottom: 0;
    }
    .close-btn {
      display: flex;
      width: 100%;
      font-size: 22px;
      color: #787a7a;
      justify-content: flex-end;
    }

    .heading {
      font-weight: 700;
      font-size: 1.5em;
      line-height: 2rem;
      margin-bottom: 1rem;
    }
    .description {
      font-size: 1em;
      .link {
        display: inline;
        margin-left: 5px;
        color: #3742fa;
      }
    }
    .register {
      .ui.form {
        width: 100%;
        text-align: left;
      }
    }
    .button-row {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      & > * {
        margin-bottom: 10px;
      }
      & > *:last-child {
        margin-bottom: 0;
      }
      .fab {
        background: #3742fa;
      }
      // .cancel {
      //   background: transparent;
      //   border: 2px solid #787a7a;
      //   color: #787a7a;
      // }
    }
  }
  //Modal Style
  /deep/ .dimmed.dimmable > .ui.animating.dimmer,
  .dimmed.dimmable > .ui.visible.dimmer,
  .ui.active.dimmer {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  /deep/ .ui.modal,
  .ui.active.modal {
    position: absolute;
    width: 450px;
    height: auto;
    margin: 0 auto !important;
    top: auto !important;
    left: calc(50% - 10vw) !important;
    transform-origin: center !important;
    transition: all ease 0.5s;
  }
  /deep/ .ui.button {
    background: transparent;
    padding: 0;
  }
  .paging {
    text-align: center;
  }
}

@media only screen and (max-width: 991px) {
  /deep/.ui.labeled.icon.button {
    padding-left: 45px !important;
    padding: 12px 10px;
  }
  /deep/.ui.dropdown > .text {
    color: $blue-primary !important;
    font-size: 10px;
  }

  .cdd-pool {
    .top-row {
      .inprogress-email-btn {
        .btn {
          margin-left: 10px;
          font-size: 10px;
          padding: 8px 10px;
          i {
            font-size: 22px;
          }
        }
      }
    }
    .filter-row {
      padding: 2rem 0;
      padding-bottom: 1rem;
      .label {
        font-size: 10px;
        margin-right: 10px;
      }
      .filters {
        .filter-btn {
          font-size: 12px;
          padding: 2px 8px;
          margin-right: 5px;
        }
      }
    }
    .cdd-list {
      .cdd-item {
        padding: 20px 15px;
        .wrap {
          .heading {
            .name {
              font-size: 1em;
            }
            .cdd-id {
              font-size: 1em;
            }
          }
          .basic-info {
            padding-top: 1rem;
            width: 100%;
            .item {
              font-size: 12px;
              flex: 0 0 100%;
              margin-bottom: 5px;
              &:last-child {
                margin-bottom: 0;
              }
            }
            .icon-text {
              i {
                font-size: 20px;
                margin-right: 10px;
              }
            }
            .label-text {
              .label {
                margin-bottom: 2px;
              }
            }
          }
        }
      }
    }
    .modal-custom {
      padding: 2rem 1rem;
      line-height: 1.5rem;
      & > * {
        margin-bottom: 1rem;
      }
      .close-btn {
        width: 100%;
        font-size: 22px;
        color: #787a7a;
        justify-content: flex-end;
      }
      .heading {
        font-size: 1.5em;
      }
    }
    //Modal Style
    /deep/ .ui.modal,
    .ui.active.modal {
      width: 90%;
      left: auto !important;
    }
  }
}
</style>
